import { apiClient } from "@/lib/apiClient";

export const notificationService = {
  async list(params = {}) { return (await apiClient.get("/notifications", { params })).data; },
  async unreadCount() { return (await apiClient.get("/notifications/unread-count")).data.unread; },
  async markRead(id) { return (await apiClient.post(`/notifications/${id}/read`)).data.notification; },
  async markAllRead() { return (await apiClient.post("/notifications/read-all")).data; },
  async dismiss(id) { return (await apiClient.post(`/notifications/${id}/dismiss`)).data; },
  async reconcile() { return (await apiClient.post("/notifications/reconcile")).data; },
  async getPreferences() { return (await apiClient.get("/notifications/preferences")).data.preferences; },
  async updatePreferences(patch) { return (await apiClient.put("/notifications/preferences", patch)).data.preferences; },
  async deliveries() { return (await apiClient.get("/notifications/deliveries")).data; },
  async dailyBriefPreview() { return (await apiClient.get("/notifications/daily-brief/preview")).data; },
  async weeklyReviewPreview() { return (await apiClient.get("/notifications/weekly-review/preview")).data; },
};

export const emitNotificationsChanged = () => window.dispatchEvent(new CustomEvent("notifications:changed"));

export const PRIORITY_STYLES = {
  critical: { dot: "bg-brand-burgundy", label: "Critical", text: "text-brand-burgundy" },
  high: { dot: "bg-red-500", label: "High", text: "text-red-600" },
  medium: { dot: "bg-brand-gold", label: "Medium", text: "text-amber-600" },
  low: { dot: "bg-brand-deep-blue", label: "Low", text: "text-brand-deep-blue" },
  info: { dot: "bg-muted-foreground", label: "Info", text: "text-muted-foreground" },
};

export const CATEGORY_LABELS = {
  business: "Business", leads: "Leads", transactions: "Transactions", compliance: "Compliance",
  marketing: "Marketing", goals: "Goals", tasks: "Tasks", billing: "Billing", support: "Support", system: "System",
};
